import type { KycStatus } from "@/modules/customers/domain/types";
import { notificationsKeys } from "@/modules/notifications/presentation/api/queries";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { CustomersListParams } from "./client";
import { customersApi } from "./client";

export const customersKeys = {
  list: (params: CustomersListParams) => ["customers", "list", params] as const,
  detail: (id: string) => ["customers", "detail", id] as const,
};

export function useCustomersQuery(params: CustomersListParams = {}) {
  return useQuery({
    queryKey: customersKeys.list(params),
    queryFn: () => customersApi.list(params),
  });
}

export function useCustomerDetailQuery(id: string) {
  return useQuery({
    queryKey: customersKeys.detail(id),
    queryFn: () => customersApi.getDetail(id),
    enabled: !!id,
  });
}

export function useUpdateCustomerKycMutation(customerId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { kycStatus: KycStatus }) =>
      customersApi.updateKyc(customerId, body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: customersKeys.detail(customerId) });
      qc.invalidateQueries({ queryKey: ["customers", "list"] });
      qc.invalidateQueries({ queryKey: notificationsKeys.summary() });
    },
  });
}
